import React, { useState, useEffect, useLayoutEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import style from './Sidebar.module.css'
import DashboardIcon from '../../assests/Dashboard.png'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { googleLogout } from '@react-oauth/google'
import { MdOutlineLocalOffer, MdBusinessCenter, MdCalendarMonth, MdGroups, MdPerson, MdSchool, MdCardMembership, MdLogout } from "react-icons/md";
import { LuNetwork } from "react-icons/lu";
import { logActivity } from "../../services/activityService";
import SidebarHeader from './SidebarHeader';
import Coins from '../../assests/Animations/CoinsGif.gif';
import PointsIcon from '../../assests/points.png';
import SadPointsIcon from '../../assests/sad.png';
import HappyPointsIcon from '../../assests/happy.png';
import Profile from '../../assests/Profile-PNG-File.png'

const Sidebar = ({ finished, setFinishPopup, timeRunning, attended, isOpen, onClose, dashboardMode, onMenuToggle, profileSlot, desktopProfileSlot }) => {
  const menu = [
    {
      id: 1,
      name: "Dashboard",
      router: "/",
      icon: DashboardIcon,
      specialPaths: ["/daily/drill", "/weekly/workout"]
    },
    {
      id: 4,
      name: "Profile",
      router: "/profile",
      icon: MdPerson
    },
    {
      id: 2,
      name: "Skills & Prep",
      router: "/learnings",
      icon: MdSchool,
      specialPaths: ["/new/learnings/detail", "/assessments"]
    },
    {
      id: 11,
      name: "Opportunities",
      router: "/opportunities",
      icon: MdBusinessCenter,
      specialPaths: ["/daily/drill", "/weekly/workout"]
    },
    {
      id: 12,
      name: "Offers",
      router: "/offers",
      icon: MdOutlineLocalOffer,
    },
    {
      id: 14,
      name: "Community",
      router: "/community",
      icon: MdGroups,
    },

    // {
    //     id:3,
    //     name:"Performance",
    //     router:"/performance",
    //     icon:PerformanceIcon
    // },

    //   {
    //       id:5,
    //       name:"Subscription",
    //       router:"/subscribe/details",
    //       icon:BillingIcon
    //   },
    //   {
    //     id:6,
    //     name:"Calendar",
    //     router:"/calendar",
    //     icon:MdOutlineEvent
    // },
    // {
    //   id:7,
    //   name:"Quiz",
    //   router:"/quiz",
    //   icon:MdQuiz
    //  },
    //  {
    //   id:8,
    //   name:"Events",
    //   router:"/events",
    //   icon:MdEventAvailable
    //  },
    //  {
    //   id:9,
    //   name:"Forum",
    //   router:"/forum",
    //   icon:TbBulb
    //  },
    {
      id: 13,
      name: "Calendar",
      router: "/calendar",
      icon: MdCalendarMonth,
    },
    {
      id: 10,
      name: "Support",
      router: "/support",
      icon: LuNetwork
    },
  ]

  const UserID = localStorage.getItem("USERID");

  const navigate = useNavigate()
  const location = useLocation()
  const { userDetails } = useSelector((state) => state.user)

  const [selectedMenu, setSelectedMenu] = useState({})
  const [rewardPoints, setRewardPoints] = useState(0)
  const [rewardMoney, setRewardMoney] = useState(0)
  const [showPointsMood, setShowPointsMood] = useState(false)
  const [showCoinsMood, setShowCoinsMood] = useState(false)
  const [profileImageUrl, setProfileImageUrl] = useState('')
  const [imageError, setImageError] = useState(false)
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false)
  const profileAnchorRef = useRef(null)
  const profilePopupRef = useRef(null)
  const [accountMenuPos, setAccountMenuPos] = useState({ top: 0, left: 0 })

  const getIsNewUser = () => {
    const cachedCompletion = (() => {
      try {
        const cached = JSON.parse(localStorage.getItem('completionSyncData') || '{}')
        return Number(cached?.profile_completion)
      } catch {
        return NaN
      }
    })()

    const stateCompletion = Number(userDetails?.profile_completion)
    const completion = Number.isFinite(cachedCompletion) ? cachedCompletion : stateCompletion
    return Number.isFinite(completion) && completion <= 0
  }

  const resolveProfileImageSrc = () => {
    if (imageError || !profileImageUrl) return Profile
    const normalizedUrl = String(profileImageUrl).trim()
    if (!normalizedUrl) return Profile
    if (normalizedUrl.startsWith('data:')) return normalizedUrl
    return `${normalizedUrl}${normalizedUrl.includes('?') ? '&' : '?'}uid=${UserID || ''}`
  }

  const handleLogout = () => {
    const isMentorUser = localStorage.getItem('mentor') === 'true'
    logActivity({ module: 'AUTH', action: 'LOGOUT', remark: 'User logged out (sidebar)' })
    localStorage.removeItem('access-token')
    localStorage.removeItem('ClubID')
    localStorage.removeItem('ORGID')
    localStorage.removeItem('USERID')
    localStorage.removeItem('mentor')
    localStorage.removeItem('roleId')
    localStorage.removeItem('learnertoken')
    localStorage.removeItem('learneruserid')
    localStorage.removeItem('username')
    localStorage.removeItem('newLearningId')
    localStorage.removeItem('MainLevelId')
    localStorage.removeItem('SubLevelId')
    localStorage.removeItem('clickedItem')
    localStorage.removeItem('clickeditemDes')
    localStorage.removeItem('functionCalled')
    localStorage.removeItem('rzp_checkout_anon_id')
    localStorage.removeItem('rzp_device_id')
    localStorage.removeItem('countrydetails')
    localStorage.removeItem('timezone')
    localStorage.removeItem('currency')
    localStorage.removeItem('adminmapped')
    localStorage.removeItem('dailySnoozeTriggered')
    localStorage.removeItem('weeklySnoozeTriggered')
    localStorage.removeItem('hasShownDailyDrill')
    localStorage.removeItem('trialUser')
    localStorage.removeItem('categoryID')
    googleLogout()
    navigate(isMentorUser ? '/login/mentor' : '/login')
    window.location.reload()
  }

  const handleClick = (item) => {
    if (location.pathname === "/daily/drill" && !finished && timeRunning && attended) {
      setFinishPopup(true)
    }
    else if (location.pathname === "/weekly/workout" && !finished && timeRunning && attended) {
      setFinishPopup(true)
    }
    else {
      if (item.kind === "logout") {
        handleLogout()
        return
      }
      logActivity({ module: "NAVIGATION", action: "MENU_CLICK", instance: item.router, remark: item.name });
      setSelectedMenu(item)
      if (item.router === "/profile/profile-details") {
        navigate(item.router, { state: { userID: UserID } })
      } else {
        navigate(item.router)
      }
      if (onClose) onClose();
    }
  }

  useEffect(() => {
    const currentMenuItem = menu.find(item =>
      item.router === location.pathname ||
      (item.specialPaths && item.specialPaths.includes(location.pathname))
    );
    if (currentMenuItem) {
      setSelectedMenu(currentMenuItem);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (UserID === null || UserID === undefined) {
      navigate("/login");
    }
  }, []);

  // Sync rewards from user details (which SidebarHeader already fetches)
  useEffect(() => {
    if (userDetails) {
      setRewardPoints(userDetails.reward_points ?? 0)
      setRewardMoney(userDetails.reward_money ?? 0)
    }
  }, [userDetails])

  useEffect(() => {
    try {
      const cached = JSON.parse(localStorage.getItem('profileImageSyncData') || '{}')
      if (cached.user_id && String(cached.user_id) !== String(UserID)) {
        localStorage.removeItem('profileImageSyncData')
      } else if (cached.profile_image) {
        setProfileImageUrl(String(cached.profile_image))
        setImageError(false)
      }
    } catch { }

    const handleProfileImageUpdate = (event) => {
      const detail = event?.detail || {}
      if (detail.user_id && String(detail.user_id) !== String(UserID)) return
      if (detail.profile_image) {
        setProfileImageUrl(String(detail.profile_image))
        setImageError(false)
      }
    }

    window.addEventListener('duno-profile-image-updated', handleProfileImageUpdate)
    return () => window.removeEventListener('duno-profile-image-updated', handleProfileImageUpdate)
  }, [])

  useLayoutEffect(() => {
    if (!isProfileMenuOpen) return

    const updatePosition = () => {
      const anchor = profileAnchorRef.current
      if (!anchor) return
      const rect = anchor.getBoundingClientRect()
      const popupEl = profilePopupRef.current
      const gap = 10
      const popupHeight = popupEl?.offsetHeight ?? 240
      const popupWidth = popupEl?.offsetWidth ?? 270

      let top = rect.top - popupHeight - gap
      if (top < 8) {
        top = rect.bottom + gap
      }
      const maxTop = Math.max(8, window.innerHeight - popupHeight - 8)
      top = Math.min(Math.max(8, top), maxTop)

      let left = rect.left
      left = Math.max(8, Math.min(left, window.innerWidth - popupWidth - 8))

      setAccountMenuPos({ top, left })
    }

    updatePosition()
    const raf = requestAnimationFrame(updatePosition)
    window.addEventListener('resize', updatePosition)
    window.addEventListener('scroll', updatePosition, true)
    return () => {
      cancelAnimationFrame(raf)
      window.removeEventListener('resize', updatePosition)
      window.removeEventListener('scroll', updatePosition, true)
    }
  }, [isProfileMenuOpen])

  useEffect(() => {
    if (!isProfileMenuOpen) return
    const handleOutsideClick = (event) => {
      if (
        profileAnchorRef.current?.contains(event.target) ||
        profilePopupRef.current?.contains(event.target)
      ) {
        return
      }
      setIsProfileMenuOpen(false)
    }
    document.addEventListener('mousedown', handleOutsideClick)
    return () => document.removeEventListener('mousedown', handleOutsideClick)
  }, [isProfileMenuOpen])


  return (
    <div className={`${style.sidebar} ${isOpen ? style.open : ''} ${style.dashboardSidebar}`}>
      <div className={style.sidebarCard}>
        <SidebarHeader
          onMenuToggle={onMenuToggle}
          profileSlot={profileSlot}
          desktopProfileSlot={desktopProfileSlot}
          showMenuIcon={true}
          showInlineProfileIcon={false}
          usePortalsForProfileIcon={false}
          showSidebarAccountMenu={false}
        />
        <div className={style.MenuContainer}>
          {menu.map((item, index) => {
            const isAfterCommunity =
              item.name === "Calendar" &&
              menu[index - 1] &&
              menu[index - 1].name === "Community";
            const isAccountDivider =
              item.kind === "account" &&
              (!menu[index - 1] || menu[index - 1].kind !== "account");

            return (
              <React.Fragment key={item.id}>
                {isAfterCommunity && <div className={style.menuDivider} />}
                {isAccountDivider && <div className={style.menuDivider} />}
                <div
                  onClick={() => {
                    handleClick(item)
                  }}
                  className={selectedMenu.id === item.id ? style.selectedMenu : style.menuItem}
                >
                  <div className={style.menuItemImage}>
                    {typeof item.icon === "string" ? (
                      <img src={item.icon} alt={item.name} />
                    ) : (
                      <item.icon />
                    )}
                  </div>
                  <div className={style.menuItemText}>
                    <p>{item.name}</p>
                  </div>
                </div>
              </React.Fragment>
            )
          })}
        </div>
        <div className={style.bottomContent}>
          <div className={style.separateLine} />
          <div className={style.rewardsRow}>
            <div className={style.rewardsUserMenu} ref={profileAnchorRef}>
              <div
                className={style.rewardsUserIcon}
                title="Account menu"
                onClick={() => setIsProfileMenuOpen((prev) => !prev)}
              >
                <img
                  src={resolveProfileImageSrc()}
                  alt="user"
                  onError={() => setImageError(true)}
                  onLoad={() => setImageError(false)}
                />
              </div>
            </div>
            {typeof document !== 'undefined' &&
              isProfileMenuOpen &&
              createPortal(
                <div
                  ref={profilePopupRef}
                  className={style.rewardsUserPopup}
                  style={{
                    position: 'fixed',
                    top: accountMenuPos.top,
                    left: accountMenuPos.left,
                    bottom: 'auto',
                    right: 'auto',
                    zIndex: 11050,
                  }}
                  role="dialog"
                  aria-label="Account menu"
                >
                  <div className={style.rewardsUserPopupHeader}>
                    <img
                      src={resolveProfileImageSrc()}
                      alt="user"
                      className={style.rewardsUserPopupAvatar}
                      onError={() => setImageError(true)}
                      onLoad={() => setImageError(false)}
                    />
                    <div className={style.rewardsUserPopupMeta}>
                      <p className={style.rewardsUserPopupName}>{userDetails?.name || "My Account"}</p>
                      <span className={style.rewardsUserPopupHint}>Manage your account</span>
                    </div>
                  </div>
                  <div className={style.rewardsUserPopupDivider} />
                  <button
                    type="button"
                    className={style.rewardsUserPopupItem}
                    onClick={() => {
                      logActivity({ module: 'PROFILE', action: 'MY_ACCOUNT_CLICK', remark: 'My Account from sidebar avatar menu' })
                      if (getIsNewUser()) {
                        navigate('/profile')
                      } else {
                        navigate('/profile/profile-details', { state: { userID: UserID } })
                      }
                      setIsProfileMenuOpen(false)
                      if (onClose) onClose()
                    }}
                  >
                    <MdPerson size={18} />
                    My Account
                  </button>
                  <button
                    type="button"
                    className={style.rewardsUserPopupItem}
                    onClick={() => {
                      logActivity({ module: 'PROFILE', action: 'MY_SUBSCRIPTION_CLICK', remark: 'My Subscription from sidebar avatar menu' })
                      navigate('/subscribe/details')
                      setIsProfileMenuOpen(false)
                      if (onClose) onClose()
                    }}
                  >
                    <MdCardMembership size={18} />
                    My Subscription
                  </button>
                  <button
                    type="button"
                    className={`${style.rewardsUserPopupItem} ${style.rewardsUserPopupLogout}`}
                    onClick={() => {
                      setIsProfileMenuOpen(false)
                      handleLogout()
                    }}
                  >
                    <MdLogout size={18} />
                    Logout
                  </button>
                </div>,
                document.body
              )}
            <div className={style.rewardsMiniDivider} aria-hidden="true" />
            <div
              className={style.pointsIconWrapper}
              onMouseEnter={() => setShowCoinsMood(true)}
              onMouseLeave={() => setShowCoinsMood(false)}
            >
              <img src={Coins} alt="Coins" className={style.rewardIconCoins} />
              {showCoinsMood && (
                <div className={style.pointsMoodPopup}>
                  <img
                    src={rewardMoney && Number(rewardMoney) > 0 ? HappyPointsIcon : SadPointsIcon}
                    alt={rewardMoney && Number(rewardMoney) > 0 ? 'Happy coins' : 'Sad coins'}
                    className={style.pointsMoodIcon}
                  />
                  <p className={style.pointsMoodText}>
                    {rewardMoney && Number(rewardMoney) > 0
                      ? `Congrats! You earned ${rewardMoney} coins`
                      : 'No coins yet'}
                  </p>
                </div>
              )}
            </div>
            <span className={style.rewardValueText}>{rewardMoney ?? 0}</span>
            <div className={style.rewardCenterDivider} />
            <div
              className={style.pointsIconWrapper}
              onMouseEnter={() => setShowPointsMood(true)}
              onMouseLeave={() => setShowPointsMood(false)}
            >
              <img src={PointsIcon} alt="Points" className={style.rewardIconPointsImage} />
              {showPointsMood && (
                <div className={style.pointsMoodPopup}>
                  <img
                    src={rewardPoints && Number(rewardPoints) > 0 ? HappyPointsIcon : SadPointsIcon}
                    alt={rewardPoints && Number(rewardPoints) > 0 ? 'Happy points' : 'Sad points'}
                    className={style.pointsMoodIcon}
                  />
                  <p className={style.pointsMoodText}>
                    {rewardPoints && Number(rewardPoints) > 0
                      ? `Congrats! You earned ${rewardPoints} points`
                      : 'No points yet'}
                  </p>
                </div>
              )}
            </div>
            <span className={style.rewardValueText}>{rewardPoints ?? 0}</span>
          </div>
          {/* <div className={selectedMenu.id===7?style.selectedBottomText:style.bottomText}>
                <p  onClick={()=>{
                  handleClick({
                    id:7,
                    name:"Support",
                    router:"/support",
                   
                })
                }} className={style.supportText}>Support</p>
            </div> */}

        </div>
      </div>
    </div>
  )
}

export default Sidebar